import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, OccEndpointsService, Product, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GgProductHighlightsAdapter } from './product-highlights.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccGgProductHighlightsAdapter implements GgProductHighlightsAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  getProduct(productCode: string, retailerActionCode: string): Observable<Product> {
    const url = this.occEndpoints.buildUrl('productHighlight', { urlParams: { productCode, retailerActionCode } });
    return this.http.get<Product>(url).pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
